import React from 'react';
import { useTranslation } from 'react-i18next';
import RedoOutlinedIcon from '@mui/icons-material/RedoOutlined';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import LinkOutlinedIcon from '@mui/icons-material/LinkOutlined';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import { useDispatch } from 'react-redux';

import CollapsedButton, {
  COLLAPSED_BUTTON_SIZES,
  COLLAPSED_BUTTON_TYPES,
} from '../../../../../components/collapsed-button/CollapsedButton';
import { removeAdjustedMessage } from '../../../../../redux/activ8/activ8MessagesReducer';

import scss from './MessageActions.module.scss';

function MessageActions({ id, onEdit, isEditing, isRedoing = false }) {
  const dispatch = useDispatch();
  const { t } = useTranslation('activ8');

  const handleRemoveMessage = () => {
    dispatch(removeAdjustedMessage(id));
  };

  return (
    <div className={scss.wrapper}>
      <CollapsedButton
        tooltip={t('redo')}
        icon={RedoOutlinedIcon}
        type={COLLAPSED_BUTTON_TYPES.SECONDARY}
        size={COLLAPSED_BUTTON_SIZES.SMALL}
        disableOpenOnHover
        onClick={() => {}}
        isLoading={isRedoing}
        disabled={isEditing || isRedoing}
      />
      <CollapsedButton
        tooltip={t('edit')}
        icon={EditOutlinedIcon}
        type={COLLAPSED_BUTTON_TYPES.SECONDARY}
        size={COLLAPSED_BUTTON_SIZES.SMALL}
        disableOpenOnHover
        onClick={onEdit}
        disabled={isEditing || isRedoing}
      />
      {/* <CollapsedButton
        tooltip={t('connect')}
        icon={LinkOutlinedIcon}
        type={COLLAPSED_BUTTON_TYPES.SECONDARY}
        size={COLLAPSED_BUTTON_SIZES.SMALL}
        disableOpenOnHover
        onClick={() => {}}
      /> */}
      <CollapsedButton
        tooltip={t('delete')}
        icon={DeleteOutlineIcon}
        type={COLLAPSED_BUTTON_TYPES.DANGER}
        size={COLLAPSED_BUTTON_SIZES.SMALL}
        disableOpenOnHover
        onClick={handleRemoveMessage}
        disabled={isEditing || isRedoing}
      />
    </div>
  );
}

export default MessageActions;
